import { Routes, Route, Navigate } from 'react-router-dom';
import { Suspense, lazy, useContext } from 'react';
import Login from './routes/guest/login.route';
import PrivateRoutes from './utils/PrivateRoute';
import { UserContext } from './contexts/user.context';
import PublicLayout from './layout/public/public.layout';
const Dashboard = lazy(() => import('./routes/dashboard/dashboard.route'));
const StepOneReg = lazy(() => import('./routes/registration/steponeReg.route'));
const UserPage = lazy(() => import('./routes/user/userpage.route'));
const FAExpensePage = lazy(() => import('./routes/expenseverification/faexpensepage.route'));
const SummaryPage = lazy(() => import('./routes/expense/summarypage.route'));
const RptExpensePage = lazy(() => import('./routes/report/expense/rptexpensepage.route'));
const ExpenseTransactionEncoding = lazy(() => import('./routes/expensetransaction/encodingreceipt.route'));
const ExpenseTransactionList = lazy(() => import('./routes/expensetransaction/listencoding.route'));
const ClassificationSettingPage = lazy(() => import('./routes/setting/classificationsettingpage.route'));
const RptExpenseSubstantiationPage = lazy(() => import('./routes/report/expense/rptexpensesubstantiationpage.route'));
const RptDisapprovePage = lazy(() => import('./routes/report/expense/rptdisapprovepage.route'));
const ChangePassword = lazy(() => import('./routes/changepassword/changepassword.route'));
const SalesReceipt = lazy(() => import('./routes/salestransaction/salesreceipt.route'));
const SalesReceiptList = lazy(() => import('./routes/salestransaction/salesreceiptlist.route'));
const SalesVerificationPage = lazy(() => import('./routes/salesverification/salesverification.route'));
const VerifyPage = lazy(() => import('./routes/verify/verifypage.route'));
const AlreadyVerifiedPage = lazy(() => import('./routes/verify/alreadyverifiedpage.route'));
const RptSalesApprovePage = lazy(() => import('./routes/report/expense/rptsalesapprovepage.route'));
const RptSalesDisapprovePage = lazy(() => import('./routes/report/expense/rptsalesdisapprovepage.route'));
const RptSalesSummaryPage = lazy(() => import('./routes/report/expense/rptsalesummarypage.route'));
const SupplierSettingPage = lazy(() => import('./routes/setting/suppliersettingpage.route'));
const RptPurchaseTransactionPage = lazy(() => import('./routes/report/expense/rptpurchasetransactionpage.route'));
const ClassificationSettingSalesPage = lazy(() => import('./routes/setting/classificationsettingsalespage.route'));
const TaxWithheldPage = lazy(() => import('./routes/tax/taxwitheldpage.route'));
const RptSummarySellPage = lazy(() => import('./routes/report/sales/rptsummarysellpage.route'));
const TaxReturnPage = lazy(() => import('./routes/taxreturn/taxreturnpage.route'));
const ProfilePage = lazy(() => import('./routes/profile/profile.route'));
const HistoryPage = lazy(() => import('./routes/history/historypage.route'));
const BusinessDocumentsPage = lazy(() => import('./routes/documents/businessdocuments.route'));
const WithHoldingRatesPage = lazy(() => import('./routes/tax/witholdingratespage.route'));
const WithholdingCategoryRatesPage = lazy(() => import('./routes/setting/withholdingcategoryratespage.route'));
const MaintananceRoute = lazy(() => import('./routes/guest/maintenance.route'));
const JournalEntryPage = lazy(() => import('./routes/generalledger/journal/journalentrypage.route'));
const JournalListPage = lazy(() => import('./routes/generalledger/journal/journallistpage.route'));
const JournalAdjustmentPage = lazy(() => import('./routes/generalledger/journal/journaladjustmentpage.route'));
const GeneralLedgerPage = lazy(() => import('./routes/generalledger/journal/generalledgerpage.route'));
const TrialbalancePage = lazy(() => import('./routes/generalledger/trialbalancepage.route'));
const CustomerPage = lazy(() => import('./routes/customer/customerroute'));
const FsLineSettingPage = lazy(() => import('./routes/setting/FsLineSettingPage.route'));
const BranchSettingPage = lazy(() => import('./routes/setting/branchsettingpage.route'));
const FSBalanceSheetPage = lazy(() => import('./routes/financialstatement/FsBalanceSheet.route'));
const MobileQrCode = lazy(() => import('./routes/download/mobileqrcode'));
const FSIncomeStatementPage = lazy(() => import('./routes/financialstatement/FsIncomeStatement.route'));
const FSCashFlowPage = lazy(() => import('./routes/financialstatement/FsCashFlow.route'));
const RegisterBookeeper = lazy(() => import('./routes/registration/bookeeper/registerBookeeper.route'));
const DashboardBookeeping = lazy(() => import('./routes/dashboard/dashboardBookeeping.route'));
const NotFoundPage = lazy(() => import('./routes/404/notfound.route'));
const PrivacyPolicyPage = lazy(() => import('./routes/privacy/privacy.route'));
const TermsAndConditionsPage = lazy(() => import('./routes/terms/terms.route'));
const DeleteAccountInstructionsPage = lazy(() => import('./routes/disableaccount/disableaccount.route'));
const FacebookAuthApiPage = lazy(() => import('./routes/facebook/facebookauth.route'));
const PlanPage = lazy(() => import('./routes/plan/plan.route'));
const FsLineSetupPage = lazy(() => import('./routes/setup/fslineSetup.route'));

const App = () => {

     const { positionUser } = useContext(UserContext);

  return (
      <Suspense fallback={<div className="p-4">Loading...</div>}>
        <Routes>
          <Route element={<PrivateRoutes/>}>
            <Route path='/setup/fsline' element={ <FsLineSetupPage /> }/>
            <Route path='/dashboard' element={ positionUser ==='Bookkeeper_'? <DashboardBookeeping /> :<Dashboard/>}/>
            <Route path='/company/setup' element={ positionUser ==='Bookkeeper_'? <DashboardBookeeping /> : <Navigate to="/dashboard" replace /> }/>
            <Route path='/expense/verification' element={ positionUser ==='Bookkeeper_'? <NotFoundPage/>: <FAExpensePage />}/>
            <Route path='/expense' element={ positionUser ==='Bookkeeper_'? <NotFoundPage/>: <SummaryPage />}/>
            <Route path='/expense/receipt' element={ positionUser ==='Bookkeeper_'? <NotFoundPage/>:<ExpenseTransactionEncoding />}/>
            <Route path='/expense/list' element={ positionUser ==='Bookkeeper_'? <ExpenseTransactionList/>: <ExpenseTransactionList />}/>
            <Route path='/expense/verification' element={ positionUser ==='Bookkeeper_'? <NotFoundPage/>: <FAExpensePage />}/>
            <Route path='/report/expense' element={ <RptExpensePage />}/>
            <Route path='/report/disapproved' element={ <RptDisapprovePage />}/>
            <Route path='/report/substantiation' element={ <RptExpenseSubstantiationPage />}/>
            <Route path='/setting/user' element={ positionUser ==='Bookkeeper_'? <NotFoundPage/>:<UserPage />}/>
            <Route path='/setting/customer' element={ positionUser ==='Bookkeeper_'? <NotFoundPage/>:<CustomerPage />}/>
  
            
            <Route path='/setting/classification' element={ <NotFoundPage/> }/>
            <Route path='/setting/classification/sales' element={ <NotFoundPage/> }/>
            <Route path='/setting/withholding/category' element={ positionUser ==='Bookkeeper_'? <NotFoundPage/>: <WithholdingCategoryRatesPage />}/>
            <Route path='/setting/fs/line' element={ positionUser ==='Bookkeeper_'? <NotFoundPage/>: <FsLineSettingPage />}/>
            <Route path='/setting/fs/mapping' element={ <Navigate to="/setting/fs/line" replace /> }/>
            <Route path='/setting/branch' element={ positionUser ==='Bookkeeper_'? <NotFoundPage/>: <BranchSettingPage />}/>
  
            
            <Route path='/setting/supplier' element={ positionUser ==='Bookkeeper_'? <NotFoundPage/>:<SupplierSettingPage />}/>
            <Route path='/change/password' element={ positionUser ==='Bookkeeper_'? <ChangePassword/>:<ChangePassword />}/>
            <Route path='/sales/receipt' element={ positionUser ==='Bookkeeper_'? <NotFoundPage/>:<SalesReceipt />}/>
            <Route path='/sales/list' element={ positionUser ==='Bookkeeper_'? <SalesReceiptList/>: <SalesReceiptList />}/>
            <Route path='/sales/verification' element={ positionUser ==='Bookkeeper_'? <NotFoundPage/>: <SalesVerificationPage />}/>
            <Route path='/report/sales' element={ <RptSalesApprovePage />}/>
            <Route path='/report/sales/disapproved' element={ <RptSalesDisapprovePage />}/>
            <Route path='/report/sales/summary' element={ <RptSalesSummaryPage />}/>
            <Route path='/report/purchase/transaction' element={ <RptPurchaseTransactionPage />}/>
            <Route path='/report/sell/transaction' element={ <RptSummarySellPage />}/>
            
  
           
            <Route path='/tax/2307' element={ <TaxWithheldPage />}/>
            <Route path='/witholding/rates' element={ <WithHoldingRatesPage />}/>
            
            <Route path='/tax/payout/:type' element={ <TaxReturnPage />}/>
            
            <Route path='/profile' element={ <ProfilePage />}/>
            <Route path='/history' element={ <HistoryPage />}/>
            <Route path='/documents' element={ positionUser ==='Bookkeeper_'? <NotFoundPage/>: <BusinessDocumentsPage />}/>
  
  
            <Route path='/journal/entry' element={positionUser ==='Bookkeeper_'? <NotFoundPage/>: <JournalEntryPage />}/>
            <Route path='/journal/list' element={ <JournalListPage />}/>
            <Route path='/journal/adjustment' element={ positionUser ==='Bookkeeper_'? <NotFoundPage/>: <JournalAdjustmentPage />}/>
            <Route path='/general/ledger' element={ <GeneralLedgerPage />}/>
            <Route path='/trial/balance' element={ <TrialbalancePage />}/>
  
            <Route path='/fs/balance/sheet' element={ <FSBalanceSheetPage />}/>
            <Route path='/fs/income/statement' element={ <FSIncomeStatementPage />}/>
            <Route path='/fs/cashflow' element={ <FSCashFlowPage />}/>
            
  
            <Route path='/qr/download' element={ <MobileQrCode />}/>
            <Route path='/plan' element={ <PlanPage />}/>
          </Route>
          <Route element={<PublicLayout />}>
            <Route path='/' element={ <Login />}/>
            <Route path='/step' element={ <StepOneReg />}/>
            <Route path='/privacy-policy' element={ <PrivacyPolicyPage />}/>
            <Route path='/terms-and-conditions' element={ <TermsAndConditionsPage />}/>
            <Route path='/register/bookeeper' element={ <RegisterBookeeper />}/>
          </Route>
          <Route path='/verify/:id' element={ <VerifyPage />}/>
          <Route path='/verified' element={ <AlreadyVerifiedPage />}/>
          <Route path='/maintainance' element={ <MaintananceRoute />}/>
          <Route path='/delete-account' element={ <DeleteAccountInstructionsPage />}/>
          <Route path='/facebook-auth' element={ <FacebookAuthApiPage />}/>
        </Routes>
      </Suspense>
    );
}
export default App;
